import { createMemo, createSignal } from 'solid-js';
import { JSX } from 'solid-js/jsx-runtime';

const cashFormatter = new Intl.NumberFormat('en-US', {
    style: 'currency',
    currency: 'USD',
    maximumFractionDigits: 0,
});

// Formats given number as USD currency (leading '$').
// No thousands separator.
// No fractional digits.  E.g., "$1200".
export function formatCurrency(x: number): string {
    return cashFormatter.format(x);
}

export const THUMBS_UP = '\u{1F44D}';
export const CHECK_MARK = '\u{2705}';

export function BetMultiplier(props: {
    val: number,
}): JSX.Element {
    return <span>
        &times;{props.val}
    </span>;
}

export function PlusSign(_props: Record<string, never>): JSX.Element {
    return <span class="text-green-700 font-sans font-extrabold text-2xl w-4 inline-block text-center">+</span>;
}

export function MinusSign(_props: Record<string, never>): JSX.Element {
    return <span class="font-sans font-extrabold text-2xl w-4 inline-block text-center">-</span>;
}

export type BoxStatus = 'emph' | 'de-emph' | 'stale';


function statusColor(status: BoxStatus): { [clz: string]: boolean } {
    if (status === 'stale') {
        return { 'border-grey-500': true };
    }
    if (status === 'de-emph') {
        return { 'border-green-700': true };
    }
    return { 'border-green-500': true };
}

export function BoxBorder(props: {
    status: BoxStatus,
    children: JSX.Element
}): JSX.Element {
    return <div
        class="border-2 p-2 w-fill"
        classList={statusColor(props.status)}
    >{props.children}</div>;
}

export function StandardButton(props: {
    onClick: JSX.EventHandler<HTMLButtonElement, MouseEvent>,
    disabled?: boolean,
    children: JSX.Element
    color: 'green' | 'red',
    spinMode?: boolean,
}): JSX.Element {
    const common = 'font-semibold py-1 px-1 sm:px-2 mx-1 sm:mx-2 border-2 rounded bg-transparent';
    const activeR = ' border-red-800 text-red-700 hover:border-transparent hover:bg-red-300 hover:text-red-500 ';
    const activeG = ' border-green-800 text-green-700 hover:border-transparent hover:bg-green-700 hover:text-white ';
    const inact = ' text-stone-700 hover:text-stone border-stone-500';

    const active = (props.color === 'red') ? activeR : activeG;
    const [getDisabled, setDisabled] = createSignal<boolean | undefined>(props.disabled);

    const spinMode = createMemo(() => {
        if (props?.spinMode === true) {
            setDisabled(true);
            return 'animate-pulse';
        }
        setDisabled(false);
        return '';
    });

    return <button
        class={common + (props.disabled ? inact : active)}
        disabled={getDisabled()}
        onClick={props.onClick}
    ><span class={spinMode()}>{props.children}</span></button>;
}

export function SpinButton(props: {
    onClick: (...el: Parameters<JSX.EventHandler<HTMLButtonElement, MouseEvent>>) => Promise<void>,
    disabled?: boolean,
    children: JSX.Element
    color: 'green' | 'red',
}): JSX.Element {
    const [getSpinMode, setSpinMode] = createSignal<boolean>(false);

    return <StandardButton
        onClick={(arg) => {
            setSpinMode(true);
            /*async*/ props.onClick(arg)
                .finally(() => {
                    setSpinMode(false);
                });
        }}
        disabled={props.disabled}
        children={props.children}
        color={props.color}
        spinMode={getSpinMode()}
    />;
}